import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { OrgchartEmployeeFragment } from 'generated/resources/graphql'

import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import DetailsValue from 'modules/org_chart/components/SidePanel/DetailsValue'

interface Props {
  employee: OrgchartEmployeeFragment
}

const WorkInformation: React.FC<Props> = ({ employee }) => {
  const manager = employee.manager
  const startDate = employee.seniorityCalculationDate || employee.referenceContract?.startsOn

  return (
    <Box
      padding="s24"
      gap="s16"
      flexDirection="column"
      border={{
        bottom: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
    >
      <Text.Header2>{i18n.t('employees.orgchart.work_information')}</Text.Header2>
      <DetailsValue label={i18n.t('employees.orgchart.reports_to')}>
        {manager && manager.fullName}
      </DetailsValue>
      <DetailsValue label={i18n.t('employees.orgchart.workplace')}>
        {employee.locationName}
      </DetailsValue>
      <DetailsValue label={i18n.t('employees.orgchart.start_date')}>
        {startDate && stringToDate(startDate, 'backend').format('MMM DD, YYYY')}
      </DetailsValue>
      <DetailsValue label={i18n.t('employees.orgchart.phone')}>{employee.phoneNumber}</DetailsValue>
    </Box>
  )
}

export default WorkInformation
